import { createUiHelper } from './create-ui-helper.js';

export function resolveUiHelper() {
  if (typeof window === 'undefined') {
    return null;
  }

  const container = window.__agpContainer || null;

  if (container && typeof container.getHelper === 'function') {
    try {
      const helper = container.getHelper('ui');
      if (helper) {
        return helper;
      }
    } catch (error) {
      // ignore helper lookup errors so we can fall back
    }
  }

  const agileUtils = window.AgileProUtils || null;
  const windowUi = window.UI && typeof window.UI === 'object' ? window.UI : null;
  if (windowUi) {
    if (container && typeof container.registerHelper === 'function') {
      try {
        container.registerHelper('ui', windowUi);
      } catch (error) {
        // ignore repeated registrations
      }
    }
    window.AgileProUtils = agileUtils || {};
    window.AgileProUtils.uiHelper = windowUi;
    return windowUi;
  }

  if (agileUtils && agileUtils.uiHelper) {
    return agileUtils.uiHelper;
  }

  const documentRef = window.document || null;
  if (!documentRef) {
    return null;
  }

  const helper = createUiHelper({ document: documentRef });
  if (!helper) {
    return null;
  }

  if (container && typeof container.registerHelper === 'function') {
    try {
      container.registerHelper('ui', helper);
    } catch (error) {
      // ignore repeated registrations
    }
  }

  window.AgileProUtils = agileUtils || {};
  window.AgileProUtils.uiHelper = helper;
  return helper;
}

if (typeof window !== 'undefined') {
  window.AgileProUtils = window.AgileProUtils || {};
  window.AgileProUtils.resolveUiHelper = resolveUiHelper;
}
